import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useOktaAuth } from '@okta/okta-react';
import Loader from '../../atoms/Loader';
import Utility from '../../utils/Utility';
import TokenManager from '../../utils/TokenManager';
const PostAuthentication = props => {
  const {
    authState
  } = useOktaAuth();
  const {
    BASE_URL,
    authenticateApiUrl,
    redirectUrl
  } = props;
  useEffect(() => {
    if (Utility.isDefined(authState)) {
      if (authState.isAuthenticated) {
        const options = {
          authenticateApiUrl: "".concat(BASE_URL).concat(authenticateApiUrl),
          redirectUrl
        };
        TokenManager.persistUserAuth(authState, options);
      } else if (!authState.isAuthenticated) {
        TokenManager.clearTokenDetails();
        TokenManager.clearAllCookies();
      }
    }
  }, [authState]);
  return /*#__PURE__*/React.createElement(Loader, {
    id: "tap-post-authentication-loader",
    top: "0"
  });
};
PostAuthentication.propTypes = {
  authenticateApiUrl: PropTypes.string.isRequired,
  BASE_URL: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string
};
PostAuthentication.defaultProps = {
  redirectUrl: '/app/home'
};
export default PostAuthentication;